import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import myResult from '@/components/resultPage/main.vue';

var ResultPage = function (_super) {
  __extends(ResultPage, _super);

  function ResultPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.data = {
      state: _this.$route.query.state || 'success',
      content: decodeURI(_this.$route.query.content || _this.$route.query.message || ''),
      buttons: [{
        type: 'primary',
        text: _this.t('返回登录页'),
        url: '/login',
        id: 'result_to_back'
      }, {
        text: _this.t('返回用户中心'),
        url: '/customer',
        id: 'result_to_customer'
      }]
    };
    return _this;
  }

  ResultPage = __decorate([Component({
    components: {
      myResult: myResult
    }
  })], ResultPage);
  return ResultPage;
}(Vue);

export default ResultPage;